<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { LabelProps } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { Label } from 'reka-ui'
import { cn } from '@ds/lib/utils'

/*
 * Reka's Label: renders a real `<label>` (or `as` anything else), forwards `for`,
 * and swallows the double-click text selection a label otherwise triggers.
 *
 * The base style is deliberately plain — the caption styles this app actually
 * uses live in DSFieldLabel, which composes this. (derived: the canonical
 * design-system project has no Label spec to reconcile against.)
 */
const props = defineProps<LabelProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <Label
    v-bind="delegatedProps"
    :class="
      cn(
        'font-ds text-sm font-medium leading-none',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        props.class,
      )
    "
  >
    <slot />
  </Label>
</template>
